import { render } from "./BasicColumnChart.vue?vue&type=template&id=3ad43838"
import script from "./BasicColumnChart.vue?vue&type=script&lang=js"
export * from "./BasicColumnChart.vue?vue&type=script&lang=js"
script.render = render

export default script